var map = {
	"./DSCF6282.jpg": 2824,
	"./DSCF6293.jpg": 1718,
	"./DSCF6302.jpg": 1555,
	"./DSCF6352.jpg": 8370,
	"./DSCF6369.jpg": 897,
	"./DSCF6374.jpg": 8257,
	"./DSCF6386.jpg": 3964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1209;